/**
 * Size Chart modal — globally delegated so it works for content injected via the
 * Section Rendering API (e.g. inside the Quick Shop modal). Opens/closes a native
 * <dialog>. No dependencies.
 */
(function () {
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      event.preventDefault();
      var id = opener.getAttribute('data-size-chart-open');
      var dialog = document.getElementById(id);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    var closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      var parent = closer.closest('dialog');
      if (parent) parent.close();
      return;
    }

    // Click on the backdrop (the dialog element itself) closes it.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('size-chart-dialog')) {
      event.target.close();
    }
  });
})();
